import { Page } from '@/components/page/Page'
import HomePdf from '@/homes/9209-seminole-156/9209Customer_Synopsis-156.pdf'
import { data, seo } from '@/homes/9209-seminole-156/info'
// import { YoutubeEmbed } from '@/components/misc/YoutubeEmbed'
// import { VerticalMargin } from '@/styles/page'
import { HomeDetailsTable } from '@/components/homes/HomeDetailsTable'
import { homeAddressStr } from '@/helpers/homes'
import SEO from '@/utils/SEO'
import { PDFHome } from '@/components/homes/PDFHome'
import { Image } from '@/components/images'
import HomeImage from '@/images/homes/9209-seminole.jpg'

export const Home9209Seminole = () => {
  return (
    <Page>
      <SEO {...seo} />
      <h1>{homeAddressStr(data)}</h1>
      {/* <VerticalMargin>
        <YoutubeEmbed embedId="elbn8PVInmo?si=BxJgA5ZZLyE440Lb" />
      </VerticalMargin> */}
      <Image src={HomeImage} alt="Front view of updated townhome in Townhomes of Lake Seminole" />
      <HomeDetailsTable data={data} />
      <hr />
      <br />
      <br />
      <h1>Beautifully Updated Townhome in Townhomes of Lake Seminole</h1>
      <h2>Your Peaceful Oasis Awaits!</h2>

      <p>Welcome to your peaceful oasis in the desirable Townhomes of Lake Seminole! This updated 3-bedroom, 2.5-bathroom townhome blends comfort, convenience, and community charm. Ideally located just minutes from the Gulf beaches, Seminole City Center, parks, and top-rated dining, this home is a true gem in a pet-friendly, all-ages waterfront community.</p>

      <p>Step through your private fenced front patio—perfect for morning coffee or gardening—and into an open, airy living space filled with natural light. The remodeled kitchen features crisp white cabinetry, matching white appliances, and a breakfast bar ideal for entertaining. The adjoining dining and living areas lead directly to your screened-in lanai, where you can unwind with views of mature landscaping and peaceful green space.</p>

      <h2>Interior Features:</h2>
      <ul>
        <li>Spacious primary suite with two large closets, including a walk-in</li>
        <li>Ensuite bath with updated vanity</li>
        <li>Two additional bedrooms with ample closet space</li>
        <li>Second full bathroom upstairs for family or guests</li>
        <li>Convenient downstairs half bath</li>
        <li>Remodeled kitchen with white cabinetry, stainless appliances, and breakfast bar</li>
        <li>Dedicated laundry room with full-size washer and dryer</li>
        <li>Abundant storage throughout</li>
      </ul>

      <h2>Additional Features:</h2>
      <ul>
        <li>Private fenced front patio</li>
        <li>Screened-in back lanai with views of mature landscaping</li>
        <li>Assigned covered parking directly in front of unit</li>
        <li>Guest parking nearby</li>
        <li>Lovingly maintained and truly move-in ready</li>
      </ul>

      <h2>Community Amenities:</h2>
      <ul>
        <li>Large pool</li>
        <li>Lighted tennis/pickleball courts</li>
        <li>Clubhouse</li>
        <li>Private dock and fishing pier on Lake Seminole</li>
        <li>Complimentary gym membership at Seminole Recreation Center</li>
      </ul>

      <p>The monthly HOA fee includes flood insurance, cable TV, internet, water, sewer, trash, roof and exterior maintenance, lawn care, pest control, and more—offering true peace of mind and hassle-free living.</p>

      <p>This home is conveniently located just:</p>
      <ul>
        <li>1.5 miles to Seminole City Center</li>
        <li>1.7 miles to St. Petersburg College – Seminole Campus and Seminole Community Library</li>
        <li>5 miles to Indian Shores Beach</li>
        <li>6 miles to Indian Rocks Beach</li>
        <li>12 miles to Clearwater Beach</li>
        <li>13 miles to downtown St. Petersburg</li>
        <li>22 miles to Tampa International Airport</li>
      </ul>

      <p><strong>Bonus: $2,500 closing cost credit for buyers using a REAL agent and the seller’s preferred lender.</strong></p>

      <p>Don’t miss your chance to own this beautifully maintained, move-in ready townhome in one of Seminole’s most sought-after communities. Whether you're looking for a primary residence, seasonal retreat, or investment opportunity, this home has it all.</p>

      <p><strong>Schedule your private showing today and experience the Florida lifestyle you’ve been dreaming of!</strong></p>

      <br />
      <h3>Call me today for more information (805) 765-1625</h3>

      <PDFHome
        src={HomePdf}
        data={data}
      />
    </Page>
  )
}